import { Image } from './Image.js';
import { Text } from './Text.js';
import { Avatar } from './Avatar.js';
import 'classnames';
import 'react';
import '../../../utils/getPrefix.js';

var Skeleton = {
  Avatar: Avatar,
  Text: Text,
  Image: Image
};

export { Skeleton };
